import React from "react"

import "./leftworkcolor.scss"

/**
 * Button for change color (text/product)
 * @component
 * @param  {object} props
 * @param  {function} props.handler - handler button onclick function
 * @param  {string} props.color - value button onclick value
 * @param  {string} props.title - title button title
 * @param  {boolean} props.active - active button state
 *
 * @example
 * const handler = () => {}
 * const color = '#000'
 * const title = 'title'
 * const active = false
 *
 * return (
 *  <ColorBtn
 *    handler={handler}
 *    color={color}
 *    title={title}
 *    active={active}
 *  />
 * )
 */
const ColorBtn = props => {
  const {handler, color, title, active = false} = props
  return (
    <div title={title} className="leftWorkColorColorBtn_cont">
      <button
        className="leftWorkColorColorBtn"
        onClick={handler}
        style={{backgroundColor: color}}
        data-value={title}
        data-color={color}
        disabled={active}
      >
        {active && <img src="/assets/img/icons/selected_icn.svg" alt={title} />}
      </button>
    </div>
  )
}

export default ColorBtn
